import React from 'react'

const AboutHeader = () => {
  return (
    <div className='w-full flex items-center flex-wrap pb-8 sm:pb-10 md:pb-12'>
      <div className='w-full md:w-1/2'>
        <div className='text-center md:text-left'>
          <h1
            className='text-3xl sm:text-4xl md:text-5xl lg:leading-normal tracking-tight font-extrabold text-gray-900'
            data-aos='flip-up'
            data-aos-duration='1000'
          >
            About Oya <br className='hidden md:block' /> Ghana APP
          </h1>

          <p
            className='mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'
            // data-aos="slide-up"
            // data-aos-duration="1000"
          >
            Oya! is the trademark name registered under the republic of Ghana
            with KOST Konsult Services. Our tagline is Arrive Alive. Oya Ghana
            thrives to outstand as a mark of distinction by encouraging a change
            and a continuous improvement and updating approach of our processes,
            implementing leading-edge technology involving all our departments
            and all of our employees, cultivating both ethical and professional
            values, considering the current diversification of services and the
            full market coverage.
          </p>
        </div>
      </div>

      <div className='w-full md:w-1/2'>
        <div className=' sm:pl-4 lg:pl-10'>
          <img
            className='w-full sm:w-5/6 mx-auto object-cover'
            src='../../assets/images/bus/img-01.png'
            alt=''
            data-aos='slide-left'
            data-aos-duration='2000'
          />
        </div>
      </div>
    </div>
  )
}

export default AboutHeader
